import styled from "styled-components";
import Info from '../components/Icon/Info';
import DropdownIcon from '../components/Icon/DropdownIcon';
import DownloadIcon from '../components/Icon/DownloadIcon';
import ProductIcon from '../components/Icon/ProductIcon';
import BrandIcon from '../components/Icon/BrandIcon';
import PPMori from "../assets/fonts/PPMori-Regular.otf"; 
import IngredientIcon from '../components/Icon/IngredientIcon';
import NextArrow from '../components/Icon/NextArrow';
import reportBuilder from "../assets/images/reportBuilder.png"
import reportBuilder2 from "../assets/images/reportBuilder2.png"
import { useEffect, useState } from "react";
import NilReport from "../components/Icon/NilReport";
import { useData } from '../context/DataProvider';
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "../hooks/useWindowSize";
import RedirectModal from "../components/RedirectModal";


const DashboardOption = ({setTab}) => {
   const { data ,sessionExpired} = useData();
   const [isOpenCategory, setIsOpenCategory] = useState(false);
   const [selectedCategory, setSelectedCategory] = useState("Select Report");
   const [selectedReport, setSelectedReport] = useState({});
  
   const navigate = useNavigate();
   
   const { width } = useWindowSize();
   const isMobile = width <= 1024;

useEffect(()=>{
  const setReport = ()=>{
    
    if (
      Array.isArray(data.quickPullReports?.reports) &&
      data.quickPullReports.reports.length > 0
    ) {
      setSelectedReport(data.quickPullReports.reports[0]);
      setSelectedCategory(data.quickPullReports.reports[0].report_title);
      
    }
  
  }
  
setReport();
},[data])
   const quickPullreportsTitles = [...new Set(data.quickPullReports.reports?.map(report => report.report_title) || [])].sort();
   
   const toggleDropdownCategory = () => setIsOpenCategory((prev) => !prev);

   const selectOptionCategory = (value) => {
       const report = data.quickPullReports.reports?.find(r => r.report_title === value);
       setSelectedReport(report);
       setSelectedCategory(value);
       setIsOpenCategory(false);
   };

   const downloadReport = (url) => {
       window.open(url, '_blank');
   };

   const StatsSection = (
    <Main3c style={isMobile ? { flexDirection: 'row', justifyContent: "space-between" } : {}}>
      <ProductCount style={{background:'#BDDEFF'}} >
        <P1><ResponsiveProductIcon/><P1Text style={{color:'#406212'}}>Products</P1Text></P1>
        <P1Text2>{data.stats ? data.stats?.stats?.products?.count : <LoaderArea><Loader /></LoaderArea>}</P1Text2>
      </ProductCount>
      <ProductCount  style={{background:'#F6FFDB'}}>
        <P1><ResponsiveBrandIcon/><P1Text style={{color:'#1A4673'}}>Brands</P1Text></P1>
        <P1Text2 style={{color:'#406212'}}>{data.stats ? data.stats?.stats?.brands?.count : <LoaderArea><Loader /></LoaderArea>}</P1Text2>
      </ProductCount>
      <ProductCount  style={{background:'#DCFFAD'}}>
        <P1><ResponsiveIngredientIcon/><P1Text style={{color:'#406212'}}>Ingredients</P1Text></P1>
        <P1Text2 style={{color:'#406212'}}>{data.stats ? data.stats?.stats?.ingredients?.count : <LoaderArea><Loader /></LoaderArea>}</P1Text2>
      </ProductCount>
    </Main3c>
  );
  
  const ReportBuilderSection = (
    <Main221 >
      <T1>
        <T1Text>Report Builder</T1Text>
        <T1Button onClick={() => navigate("/report-builder")}>
          <T1ButtonText>Go To</T1ButtonText>
          <ResponsiveNextArrow />
        </T1Button>
      </T1>
      <ReportBuilderImgArea>
        <ReportBuilderImg alt="report builder" src={isMobile ? reportBuilder2 : reportBuilder} />
      </ReportBuilderImgArea>
    </Main221>
  );
  const QuickPullReportsSection = (
    <Main211  style={isMobile ? { width: '277px',height:'371px'} : {}}>
                   <Main2111E><Main2111>
                       <Main2111Text>
                           Quick pull report
                       </Main2111Text>
                       <InfoDiv>
                       
                       <Info/>
                       </InfoDiv>
                   </Main2111>
                   <M1111Txt2>
                   Need a custom report? <ContactTxt href="mailto:hello@cosmetic-iq.com">Contact us.</ContactTxt>
                   </M1111Txt2>
                   </Main2111E>
                   <Main2112>
                       <DropdownWrapper>
                           <DropdownInput onClick={toggleDropdownCategory}>
                               {selectedCategory}
                               <DropdownIcon />
                           </DropdownInput>
                           <OptionsList isOpen={isOpenCategory}>
                               {quickPullreportsTitles.map((category, index) => (
                                   <DropdownOption
                                       key={category}
                                       onClick={() => selectOptionCategory(category)}
                                       style={{
                                           borderTopLeftRadius: index === 0 ? "8px" : "0",
                                           borderTopRightRadius: index === 0 ? "8px" : "0",
                                           borderBottomLeftRadius: index === quickPullreportsTitles.length - 1 ? "8px" : "0",
                                           borderBottomRightRadius: index === quickPullreportsTitles.length - 1 ? "8px" : "0",
                                       }}
                                   >
                                       {category}
                                   </DropdownOption>
                               ))}
                           </OptionsList>
                       </DropdownWrapper>

                       {selectedCategory !== "Select Report" ? (
                           <Main2a>
                               <Main2a1>
                                   <Main2a11>
                                       <Main2a11Text>
                                           {selectedReport.report_title}
                                       </Main2a11Text>
                                       <Main2a11Text>
                                           {selectedReport.report_date}
                                       </Main2a11Text>
                                   </Main2a11>
                                   <Main2bText>
                                       {selectedReport.report_category}
                                   </Main2bText>
                                   <Main2bSubText>
                                       {selectedReport.report_description}
                                   </Main2bSubText>
                               </Main2a1>
                               <Main2c onClick={() => downloadReport(selectedReport.report_url)}>
                                   <ResponsiveDownloadIcon/>
                                   <Main2cText>
                                       Download the full report
                                   </Main2cText>
                               </Main2c>
                           </Main2a>
                       ) : (
                           <Main2B>
                               <NilReport/>
                           </Main2B>
                       )}
                   </Main2112>
               </Main211>
  )
   const SearchedProductsSection = (
    <>
    <SearchedProducts>
                   <S1>
                       <Main2111Text>Most searched products</Main2111Text>
                       <T1Button 
                           style={{background:'linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)'}}
                           onClick={() => navigate("/most-searched")}
                       >
                           <T1ButtonText>VIEW ALL</T1ButtonText>
                           <ResponsiveNextArrow/>
                       </T1Button>
                   </S1>
                   <PopularProducts>
                       {data.stats? data.popularProducts.slice(0, 6).map((product) => (
                           <S2 key={product.id}>
                               <S21>
                                   <S211>
                                       <S2111>
                                           <PImage  src={product.image.small} alt={product.name}/>
                                       </S2111>
                                       <S212>
                                           <S212Txt>{product.brand}</S212Txt>
                                           <S212Txt2>
                                               {product.name}
                                           </S212Txt2>
                                       </S212>
                                   </S211>
                               </S21>
                           </S2>
                       ))
                       : <LoaderArea><Loader/></LoaderArea>
                    }
                   </PopularProducts>
               </SearchedProducts>
               </>)

               const NewProductsSection = (
                <Main222>
                <Main2221>
                    <Main2111Text>New products</Main2111Text>
                    <T1Button 
                        style={{background:'linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%)'}}
                        onClick={() => navigate("/new-products")}
                    >
                        <T1ButtonText>VIEW ALL</T1ButtonText>
                        <ResponsiveNextArrow/>
                    </T1Button>
                </Main2221>
                <M1>
                    {data?.stats ?  data.newProducts?.slice(0, 50).map((product) => (
                        <M11 key={product.id}>
                            <M111>
                                <NImage src={product.image.fullsize}   alt={product.name}/>
                            </M111>
                            <M1111>
                                <S212Txt>{product.brand}</S212Txt>
                                <S212Txt2>
                                  
                                        {product.name}
                                </S212Txt2>
                            </M1111>
                        </M11>
                    ))
                    : <LoaderArea><Loader/></LoaderArea>
                 }
                </M1>
            </Main222>
               )

               const IndustryNewsSection = (
                <N>
                <Main2111Text>Industry news</Main2111Text>
                <N1>
                    {data?.stats 
                     ? data.industryNews.articles?.map((news,index) => (
                        <N11 key={index} target="_blank" rel="noopener noreferrer" href={news.article_url}>
                            <N11Txt style={{color:'#2F323799'}}>
                                {news.article_title}
                            </N11Txt>
                            <N11Txt>
                                {news.article_description}
                            </N11Txt>
                        </N11>
                    ))
                    : <LoaderArea><Loader/></LoaderArea>
                 }
                </N1>
            </N>)
   return (
       <Main2>
        <RedirectModal isOpen={sessionExpired}/>
           {data.stats === null ?  <LoaderArea><Loader /></LoaderArea> :
           <>
           {isMobile ? (
            <div style={{width: "100%",display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',gap:10}}>
            <div style={{ width: "100%",display: "flex",justifyContent:'center',flexDirection: 'row', gap: 10 }}>
               
{QuickPullReportsSection}
               
  <div style={{ width: '100%',display: "flex", flexDirection: 'column', gap: 10 }}>
    {ReportBuilderSection}
    {StatsSection}
  </div>
  

  </div>
  
  {SearchedProductsSection}
  
  <div style={{ width: "100%", display: "flex",justifyContent:'space-between',flexDirection: 'row', gap: 30 }}>
  {IndustryNewsSection}
  {NewProductsSection}
  </div>
  </div>
) : (
  <>
  <Main21 >
  {QuickPullReportsSection}
    {StatsSection}
    {ReportBuilderSection}
    </Main21>
    {
      width <= 1240 ?
    <>
    
    {SearchedProductsSection}
    {IndustryNewsSection}
    {NewProductsSection}
    
    
  </>
  :
  < Main21>
    
  
  
  {SearchedProductsSection}
  {NewProductsSection}
  {IndustryNewsSection}
  
</Main21>
  
}

  </>
  
)

}


               {/* <Main221>
                   <T1>
                       <T1Text>Report Builder</T1Text>
                       <T1Button onClick={() => navigate("/report-builder")}>
                           <T1ButtonText>Go To</T1ButtonText>
                           <ResponsiveNextArrow/>
                       </T1Button>
                   </T1>
                   <ReportBuilderImgArea >
                       <ReportBuilderImg alt="report builder" src={reportBuilder}  />
                   </ReportBuilderImgArea>
               </Main221> */}
           {/* </Main21> */}

           {/* <Main212> */}
               

             

              
           {/* </Main212> */}
           </>
}
       </Main2>
   );
};


export default DashboardOption;


const Main2 = styled.div`

padding: 30px;
display:flex;
flex-direction:row;
flex-wrap:wrap;
gap:30px;

// justify-content:space-between;
// align-items:center;



`;
const Main21 = styled.div`
display:flex;
gap: 30px;


justify-content:space-between;
width:100%;




`;
const DropdownWrapper = styled.div`
  position: relative;
height:31px;
  display: flex;
  flex-direction: column;
  align-items:center;
  padding-right:12px;
  padding-left:12px;
  padding: 8px 12px 8px 12px;
border-radius: 64px;
display:flex;
align-items:center;
justify-content: space-between;
flex-direction:row;

background:#F9F9F9;
 
  
`;

const LoaderArea = styled.div`
width:100%;
height:100%;
align-items:center;
display:flex;
justify-content:center;

`

const DropdownInput = styled.div`
  width: 100%;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;

  border: 1px solid #d1d1d1;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  align-items: center;
  padding: 12px;

gap: 0px;
border-radius: 12px;
display:flex;


@media (max-width: 1600px) {

height:51px;
baclkground:red;
//  width:402px;

}
 @media (max-width: 1240px) {

height:31px;
//  width:253px;
 

}

  
border:none;
  outline:none;
  &:hover {
    border-color: #000; /* Optional hover effect */
  }
`;

const Main212 = styled.div`
display:flex;
justify-content:space-between;
gap: 30px;
width:100%;

`;
const ReportBuilderImg = styled.img`
  width: 90%;
  height:90%;
  max-width: 100%;
  
  // border-radius:24px;
  
  object-fit: cover;
   object-position: left ;
`
const ReportBuilderImgArea = styled.div`
align-items:end;
display:flex;
height: 80%;

justify-content:end;

`
const Main2B = styled.div`

display:flex;
justify-content:center;
align-items:center;
height: 188px;
gap: 10px;
border-radius: 16px;
background: #F9F9F9;

opacity: 0px;
border: 1px solid #2F323766;
border-style:dashed;

@media (max-width: 3840px) {

height:619px;

}
@media (max-width: 2560px) {

height:357px;

}

@media (max-width: 1920px) {

height:246px;

 
 

}

@media (max-width: 1600px) {


height:188px;

}
 @media (max-width: 1240px) {

height:210px;
 width:250px;
 

}
@media (max-width: 1024px) {

height:210px;
 width:237px;
 

}

`

const OptionsList = styled.ul`
  position: absolute;
  
  top: calc(100% + 4px);
  width: 96%;
  list-style: none;
  margin: 0;
  padding: 0px ;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 24px rgba(47, 50, 55, 0.1);
  z-index: 10;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  
`;
const Main211 = styled.div`
width: 30%;

heigh:371px;
padding: 24px;
gap: 60px;
border-radius: 24px;
border:none;
background:#FFFFFF;

box-shadow: 0px 0px 24px 0px #2F323705;
display:flex;
flex-direction:column;
justify-content:space-between;
@media (max-width: 3840px) {

width:974px;
 height:931px;

}
@media (max-width: 2560px) {

height:600px;
 width:600px;

}
@media (max-width: 1920px) {

height:451px;
 width:570px;

}
 @media (max-width: 1600px) {

height:361px;

 width:450px;
 

}
 @media (max-width: 1440px) {

height:361px;
 width:384px;

}
 @media (max-width: 1240px) {

height:371px;
 width:301px;
 gap: 40px;
 

}
@media (max-width: 1024px) {

height:371px;
 width:377px;

}

`;

const DropdownOption = styled.li`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #202327;
  cursor: pointer;

  &:hover {
    background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
    
    
  }
`;
const Main2111E = styled.div`
display:flex;
flex-direction:column;
justify-content:space-between;
gap:8px;

`
const Main2111 = styled.div`
display:flex;
justify-content:space-between;
align-items:center;
// height:22px;
// background:red;


`
const Main2111Text = styled.p`

font-size: 20px;
font-weight: 600;
line-height: 22px;
letter-spacing: -0.01em;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;

margin:0;

// @media (max-width: 2560px) {
// font-size: 26px;
// }

// @media (max-width: 1600px) {
// font-size: 18px;
// }


`
const InfoDiv = styled.span`
margin-left: 8px;
  cursor: pointer;
  position: relative;
  
&:hover::after {
    content: "Access exclusive market reports generated by SKINSKOOL team"; /* Tooltip text */
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1;
  }`
const Main2112 = styled.div`
display:flex;
flex-direction:column;

gap:12px;
@media (max-width: 3840px) {

// width: 402px;
height: 688px;

}
@media (max-width: 2560px) {

// width: 402px;
height: 409px;

}
@media (max-width: 1920px) {

// width: 402px;
height: 392px;

}

@media (max-width: 1600px) {

// width: 402px;
height: 261px;

}
@media (max-width: 1240px) {

height:233px;
//  width:253px;
 

}

`

const Main2a = styled.div`


padding: 24px;

border-radius: 16px;
display:flex;
flex-direction:column;
justify-content: space-between;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);
height: 100%;

@media (max-width: 1240px) {

height:200px;
 width:253px;
 padding:12px;

}
 @media (max-width: 1024px) {

height:220px;
 width:231px;


}
`
const Main2a1 = styled.div`


@media (max-width: 3840px) {

height:140px;



}
@media (max-width: 2560px) {

height:120px;



}
@media (max-width: 1920px) {

height:78px;

}
@media (max-width: 1600px) {

height:68px;


}
@media (max-width: 1240px) {

height:68px;


}


// height:78px;
`;

const Main2a11 = styled.div`

display:flex;
justify-content:space-between;
flex-direction:row;
height:12px;
@media (max-width: 3840px) {

height:20px;

}
@media (max-width: 2560px) {

height:18px;

}
@media (max-width: 1920px) {

height:14px;

}
@media (max-width: 1600px) {

height: 6px;

}

@media (max-width: 1240px) {

height: 16px;

}
 
`

const Main2a11Text = styled.p`
font-family:PPMori;
font-size: 10px;
font-weight: 800;
line-height: 12px;
letter-spacing: -0.01em;
// text-align: center;
color:#2F3237;

// @media (max-width: 3840px) {
//   font-size: 22px;
//   }
// @media (max-width: 2560px) {
//   font-size: 16px;
  
//   }
  

// @media (max-width: 1920px) {
//   font-size: 12px;
//   }
//   @media (max-width: 1440px) {
//   font-size: 10px;
//   }
`
const Main2bText = styled.p`
font-family:PPMori;
font-size: 20px;
font-weight: 600;
line-height: 22px;
letter-spacing: -0.01em;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;
height:40%;


// @media (max-width: 3840px) {
//   font-size: 30px;
//   }
// @media (max-width: 2560px) {
//   font-size: 25;
  
//   }
  

// @media (max-width: 1920px) {
//   font-size: 22px;
//   }
//   @media (max-width: 1600px) {
//   font-size: 22px;
//   }
  @media (max-width: 1440px) {
  font-size: 18px;
  }
 
`
const Main2bSubText = styled.p`
font-family:PPMori;

font-size: 12px;
font-weight: 500;
line-height: 15.6px;
height:60%;

color:#2F323799;


// @media (max-width: 3840px) {
//   font-size: 24px;
//   line-height: 26px;
//   }
// @media (max-width: 2560px) {
//   font-size: 20px;
  
//   line-height: 20px;
  
//   }
//   @media (max-width: 1920px) {
//   font-size: 18px;
  
//   line-height: 18px;
  
//   }
//   @media (max-width: 1920px) {
//   font-size: 14px;
//   line-height: 16px;
//   }
//   @media (max-width: 1600px) {
//   font-size: 12px;
//   line-height: 14px;
//   }
  @media (max-width: 1600px) {
  font-size: 12px;
  line-height: 12.6px;
  
  }
 
`

const Main2c =styled.button`
display:flex;
align-items:center;

cursor:pointer;
background:transparent;
border:none;
@media (max-width: 3840px) {

height:24px;
gap:10px;

}
@media (max-width: 2560px) {

height:22px;

gap:8px;

}
@media (max-width: 1920px) {

height:6px;
gap:6px;


}
@media (max-width: 1240px) {

// height:10px;
gap:6px;

}

`

const Main3c =styled.div`
display:flex;
align-items:center;
// justify-content:center;

width: 22%;
gap:6px;

flex-direction:column;
@media (max-width: 3840px) {
width: 976.11px;
height:931px;

}
@media (max-width: 2560px) {
width: 659.58px;
height:600px;

}
@media (max-width: 1920px) {
width: 418.33px;
height: 451px;
}
@media (max-width: 1600px) {
width: 338px;
height: 361px;
}
@media (max-width: 1440px) {
width: 240px;
height: 361px;
}
@media (max-width: 1240px) {
width: 207px;
height: 371px;


}
@media (max-width: 1024px) {
width:485px;
height:121px;

}
`
const Main2cText = styled.p`
font-family:PPMori;
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
// text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;

//  @media (max-width: 3840px) {
// font-size: 28px;
// line-height: 31px;
// }
// @media (max-width: 2560px) {
// font-size: 20px;
// line-height: 22px;
// }
@media (max-width: 1600px) {
font-size: 13px;

}
`
const ProductCount = styled.div`
width: 100%;

height: 33%;
padding: 54px;
border-radius: 24px;
display:flex;
flex-direction:column;
justify-content: space-between;
opacity: 0px;

box-shadow: 0px 0px 24px 0px #2F323705;

@media (max-width: 3840px) {
  width: 976.11px;
  height:306.33px;


  padding:48px 64px;

  }

@media (max-width: 2560px) {
height: 196px;

width:659.58px;
padding:32px 48px;

}

@media (max-width: 1920px) {
height: 146.33px;
width:418px;
padding:32px;
}

@media (max-width: 1600px) {
height: 116.33px;
width:338px;
padding:20px 24px;
}

@media (max-width: 1440px) {
  height: 116.33px;
  width:240px;
  padding:20px 24px;
  
  
  }
  

@media (max-width: 1240px) {
height: 119.67px;
width:207px;


}

`

const P1 = styled.div`
display:flex;
align-items:center;

gap: 8px;
`

const P1Text = styled.p`
font-family:PPMori;
font-size: 14px;
font-weight: 600;
line-height: 14px;
color:#1A4673;
margin:0;

// @media (max-width: 3840px) {
//   font-size: 28px;
//   }
// @media (max-width: 2560px) {
// font-size: 20px;
// }
// @media (max-width: 1920px) {
// font-size: 16px;
// }

`
const P1Text2 = styled.p`
font-family:PPMori;
font-size: 32px;
font-weight: 600;
line-height: 35.2px;
letter-spacing: -0.01em;
text-align: left;
color:#1A4673;
margin:0;

// @media (max-width: 3840px) {
// font-size: 84px;
// }
// @media (max-width: 2560px) {
// font-size: 56px;
// }
// @media (max-width: 1920px) {
// font-size: 36px;
// }
// @media (max-width: 1024px) {
// font-size: 28px;
// }

`
const BrandCount = styled.div`
width: 100%;

height: 33%;
padding: 24px ;
border-radius: 24px;
display:flex;
flex-direction:column;
justify-content: space-between;
opacity: 0px;
background:#F6FFDB;

@media (max-width: 1240px) {
height: 96.33px;
}
@media (max-width: 1600px) {
height: 116.33px;
width:338px;

}

`
const P2Text = styled.p`
font-family:PPMori;
font-size: 14px;
font-weight: 600;
line-height: 14px;
color:#406212;

`
const P2Text2 = styled.p`
font-family:PPMori;
font-size: 32px;
font-weight: 600;
line-height: 35.2px;
letter-spacing: -0.01em;
text-align: left;
color:#406212;

`
const IngredientCount = styled.div`
width: 100%;

height: 33.33%;
padding: 24px ;
border-radius: 24px;
display:flex;
flex-direction:column;
justify-content: space-between;
opacity: 0px;
background:#DCFFAD;
box-shadow: 0px 0px 24px 0px #2F323705;
@media (max-width: 1240px) {
height: 96.33px;
}
@media (max-width: 1600px) {
height: 116.33px;
width:338px;

}

`


const P3Text = styled.p`
font-family:PPMori;
font-size: 14px;
font-weight: 600;
line-height: 14px;
color:#406212;

`
const P3Text2 = styled.p`
font-family:PPMori;
font-size: 32px;
font-weight: 600;
line-height: 35.2px;
letter-spacing: -0.01em;
text-align: left;
color:#406212;

`

const SearchedProducts = styled.div`
// flex:1;
// width:34%;

padding: 24px;
border-radius: 24px;
display:flex;
flex-direction:column;
justify-content: space-between;
gap:24px;
background:#FFFFFF;


@media (max-width: 1240px) {

width:950px;
height:262px;

}
@media (max-width: 1024px) {

width:772px;
height:254px;

}
`
const S1 = styled.div`
height: 30px;
width:100%;

display:flex;
align-items:center;
justify-content: space-between;


`

const S1Text = styled.p`
font-family:PPMori;
font-size: 20px;
font-weight: 600;
line-height: 22px;
letter-spacing: -0.01em;

text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;

@media (min-width: 1920px) {
font-size: 32px;
}
@media (min-width: 3840px) {
font-size: 50px;
}
`

const S2 = styled.div`


display:flex;
justify-content:space-between;
flex-direction:row;
flex-wrap:wrap;





gap: 24px;


@media (max-width: 1240px) {
flex: 0 1 calc(33.333% - 20px); // 3 per row with a bit of gap
  // margin-bottom: 20px;
width: 297.33px;

height: 70px;
}

@media (max-width: 1024px) {
flex: 0 1 calc(33.333% - 20px); // 3 per row with a bit of gap
  // margin-bottom: 20px;
width: 228px;


height: 70px;
}

`
const S21 = styled.div`


display:flex;

justify-content:space-between;

flex-direction:column;


@media (max-width: 1240px) {



height: 70px;
}
@media (max-width: 1024px) {

width:228px;


height: 70px;
}

`
const S211 = styled.div`
gap: 12px;
align-items:center;

display:flex;

@media (max-width: 1240px) {

width:297px;



height: 70px;
}
@media (max-width: 1024px) {

width:228px;


height: 70px;
}
`

const S2111 = styled.div`
// width: 70px;
// height:70px;
// padding: 6px ;
// gap: 20.87px;
// border-radius: 12px ;




`

const PImage = styled.img`
width:70px;
height:70px;
@media (min-width: 3840px) {
width:180px;
height:180px;
}
@media (min-width: 2560px) {
width:130px;
height:130px;
}
@media (min-width: 1920px) {
width:90px;
height:90px;
}

`
const NImage = styled.img`
width:120px;
height:120px;
object-fit: contain;
@media (max-width: 3840px) {
width:280px;
height:249px;
}
@media (max-width: 2560px) {
width:240px;
height:213.33px;
}
@media (max-width: 1920px) {
width:180px;
height:180px;
}
@media (max-width: 1240px) {
width:120px;
height:120px;
}
@media (max-width: 1024px) {
width:101px;
height:90px;
}
`
const S212 = styled.div`

width:128px;

height:48px;
display:flex;
// justify-content: space-between;
flex-direction:column;
gap: 2px;

@media (max-width: 1600px) {

width:137px;


height: 48px;
}
@media (max-width: 1440px) {

width:97px;


height: 48px;
}
@media (max-width: 1240px) {

width:215.33px;


height: 31px;
}
@media (max-width: 1024px) {

width:146px;


height: 48px;
}
`

const S212Txt = styled.p`
font-family:PPMori;

font-size: 12px;
font-weight: 600;

text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F323799;
margin:0;
@media (max-width: 3840px) {
font-size: 22px;
}
@media (max-width: 2560px) {
font-size: 18px;
}
@media (max-width: 1920px) {
font-size: 14px;
line-height: 12px;
}
`

const S212Txt2 = styled.p`
font-family:PPMori;
font-size: 12px;
font-weight: 600;


line-height: 16.69px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237; 
margin:0;
// @media (max-width: 3840px) {
// font-size: 28px;
// line-height: 31px;
// width:327px;
// }
// @media (max-width: 2560px) {
// font-size: 20px;
// width:216px;
// line-height: 20px;



// }
// @media (max-width: 1920px) {
// font-size: 15px;
// line-height: 15px;
// width:176px;




// }
// @media (max-width: 1600px) {
// font-size: 13px;
// width:137px;
// }

// @media (max-width: 1440px) {

// // width:97px;
// }
// @media (max-width: 1024px) {
// font-size: 13px;
// // width:215px;
// }

`

const Main221 = styled.div`

width:40%;


display:flex;
justify-content:space-between;
flex-direction:column;

border-radius: 24px;
box-shadow: 0px 0px 24px 0px #2F323705;

background:#BDDEFF;
@media (max-width: 3840px) {
  width: 1237.89px;
  height: 931px;
  
  
  
  }
@media (max-width: 2560px) {
  width: 808.42px;
  height:608px;
  
  
  }
@media (max-width: 1920px) {
  width: 599.67px;
  height:451px;
  
  
  }
  @media (max-width: 1600px) {
  width: 480px;
  height:361px;
  
  }
  @media (max-width: 1440px) {
  width: 480px;
  hegiht: 361px;
  }
@media (max-width: 1240px) {
width: 460px;
hegiht: 371px;
}
@media (max-width: 1024px) {
width: 485px;
height: 240px;

}

`

const T1 = styled.div`
height: 30px;
padding: 30px;

display:flex;
align-items:center;
justify-content: space-between;

@media (max-width: 3840px) {
 
 
  padding:61.55px;
  
  
  }
@media (max-width: 2560px) {
 
 
  padding:40.42px;
  
  }
@media (max-width: 1920px) {
 
 
  padding:32px;
  
  }
  @media (max-width: 1600px) {
 
 
  padding:24px;
  }





`
const T1Text = styled.p`
font-family:PPMori;
font-size: 20px;
font-weight: 600;
line-height: 22px;
letter-spacing: -0.01em;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;

// @media (max-width: 3840px) {
// font-size: 50px;
// }
// @media (max-width: 2560px) {
// font-size: 28px;
// }

// @media (max-width: 1600px) {
// font-size: 18px;
// }
`

const T1Button = styled.button`
height: 30px;
width:129px;
padding: 8px 14px 6px 14px;
gap: 8px;
cursor:pointer;
border-radius: 64px;
border:none;
background:#FFFFFF;
align-items:center;
display:flex;
justify-content: center;
// @media (max-width: 3840px) {
// width: 306px;
// height:76px;
// }
// @media (max-width: 2560px) {
// width: 216.47px;
// height:53px;
// }
// @media (max-width: 1920px) {
// width: 156px;
// height:35px;
// }

// @media (max-width: 1920px) {
// width: 156px;
// height:35px;
// }

// @media (max-width: 1600px) {
// width: 108px;
// height:30px;
// }

`
const PopularProducts = styled.div`

display:flex;
flex-wrap:wrap;

gap:12px;


justify-content:flex-start;
@media (max-width: 2560px) {

width:562px;


}
@media (max-width: 1600px) {

width:452px;


}
@media (max-width: 1440px) {

width:382px;


}
@media (max-width: 1240px) {

width:940px;
height:152px;

}

@media (max-width: 1024px) {
width:722px;

height:152px;



}

`
const T1ButtonText = styled.p`
font-fmaily: PPMori;

font-size: 12px;
font-weight: 800;
line-height: 14.4px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;


// @media (max-width: 3840px) {
// font-size: 28px;

// }
// @media (max-width: 2560px) {
//   font-size: 20px;
// }

// @media (max-width: 1920px) {
//   font-size: 14px;
  
// }
//   @media (max-width: 1600px) {
//   font-size: 10px;
  
// }

`

const Main222 = styled.div`
// width:34%;
// height: 361px;
box-sizing: border-box;
margin:0;
padding: 24px;

border-radius: 24px;
display:flex;
overflow:scroll;
gap:10px;
justify-content: space-between;
flex-direction:column;
background:#FFFFFF;
box-shadow: 0px 0px 24px 0px #2F323705;

@media (max-width: 1240px) {
width:555px;
height: 273px;

}
@media (max-width: 1024px) {
width:522px;
height: 265px;

}

`

const Main2221 = styled.div`
height: 30px;
width:100%;
display:flex;
align-items:center;
justify-content: space-between;

`


const M1 = styled.div`
  display: flex;
  gap: 10px;
  opacity: 0px;
  max-width:1399px;
  overflow: auto; /* Changed from scroll to auto for better behavior */
  
  /* Custom scrollbar styles - always visible */
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px; /* For horizontal scroll if needed */
  }
  
  &::-webkit-scrollbar-track {
    background: #e0e0e0; /* Grey track */
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #000000; /* Black thumb */
    border-radius: 2px;
  }
  
  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: #000000 #e0e0e0; /* Black thumb on grey track */

  @media (max-width: 1240px) {
    width: 520px;
    gap: 10px;
  } 
  
  @media (max-width: 1024px) {
    width: 442px;
  } 
`;
const M11 = styled.div`

display:flex;
flex-direction:column;
gap: 12px;
opacity: 0px;


@media (max-width: 1024px) {
width:120px;
height: 163px;

}


`
const M111 = styled.div`

background: #F9F9F9;
padding:10px;
border-radius: 24px;
display:flex;
justify-content: center;
align-items: center;

@media (max-width: 1440px) {
width:180px;
height:180px;
}

@media (max-width: 1024px) {
width:120px;
height:120px;
}
`


const M1111 = styled.div`
  width: 180px;
  padding: 0px 10px 0px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;  
  opacity: 0px;

  @media (max-width: 1240px) {
width:120px;
height: 31px;

}

  
`

const M1111Txt = styled.p`
 
  font-size: 12px;
  font-weight: 600;
  line-height: 16.69px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #2F323799;
  margin: 0;
  @media (max-width: 1024px) {
width:100px;
height:17px;

}
`

const M1111Txt2 = styled.p`
 
  font-size: 14px;
  font-weight: 500;
  line-height: 16.69px;
  text-align: left;
  letter-spacing: 0%;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #2F3237;
  margin: 0;
 
`
const ContactTxt = styled.a
`
cursor:pointer;
color: #2F3237;

`

const N = styled.div`

  padding: 24px;
  box-sizing: border-box;
  
  gap: 30px;
  border-radius: 24px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  
  background: #DCFFAD;
//   max-height: 361px;
@media (max-width: 3840px) {
width: 630px;
// height: 931px;
} 
@media (max-width: 2560px) {
padding: 48px;


// height: 600px;
}
@media (max-width: 1920px) {
padding: 32px;


// height: 451px;

}

@media (max-width: 1600px) {
padding: 24px;
  
  // height: 361px;
  
  
  }
@media (max-width: 1440px) {

height: 361px;

}
@media (max-width: 1240px) {
width:360px;
height: 273px;
} 
 @media (max-width: 1024px) {
width:240px;
height: 265px;
}
@media (max-width: 768px) {
width:100%;
padding-left: 52px;
padding-right: 52px;
}
`
const N1 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow: auto;
  
  /* Custom scrollbar styles */
  &::-webkit-scrollbar {
    width: 4px;  /* Increased width for better visibility */
  }
  
  &::-webkit-scrollbar-track {
    background: #grey;  /* Visible track color */
    border-radius: 1px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: black;
    border-radius: 1px;
  }
  
  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: black #grey;  /* Thumb and track color */
  
  /* Responsive heights - keep your existing media queries */
  @media (max-width: 3840px) {
    gap: 24px;
    height: 651px;
  }
  
  @media (max-width: 2560px) {
    gap: 14px;
    height: 366px;
  }
  
  @media (max-width: 1920px) {
    height: 290px;
  }
  
  @media (max-width: 1600px) {
    height: 262px;
  }
  
  @media (max-width: 1240px) {
    height: 176px;
  }
  
  @media (max-width: 1024px) {
    height: 193px;
  }
`;



const N11 = styled.a`
// width:200px;

display:flex;
flex-wrap:wrap;
flex-direction:column;

gap:4px;
text-decoration:none;
@media (max-width: 3840px) {
gap:8px;
// height: 1px;
}
@media (max-width: 2560px) {

gap:4px;
// height: 81px;

}
// @media (max-width: 1920px) {
// width:232px;
// height: 62px;

// }
// @media (max-width: 1240px) {

// height: 55px;
// }
// @media (max-width: 1024px) {

// height: 55px;
// }
`

const N11Txt = styled.p`
font-family:PPMori;
font-size: 13px;
font-weight: 600;
line-height: 16.69px;
text-align: left;
width:90%;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color:#2F3237;
 margin: 0;
 
// @media (max-width: 2560px) {
// font-size: 18px;
// line-height: 18px;
// }

// @media (max-width: 1920px) {
//   font-size: 15px;
//   line-height: 15px;
  
//   }
// @media (max-width: 1600px) {
// font-size: 13px;
// line-height: 16px;

// }
`
const ResponsiveDownloadIcon = styled(DownloadIcon)`
  width: 18px;
  height: 18px;

//  @media (max-width: 3840px) {
// width: 28px;
//   height: 31px;


// }
// @media (max-width: 2560px) {
// width: 22px;
//   height: 22px;


// }

// @media (max-width: 1920px) {
//   width: 20px;
//   height: 20px;

  
  
//   }
// @media (max-width: 1600px) {
// width: 18px;
//   height: 18px;



// }
`;

const ResponsiveProductIcon = styled(ProductIcon)`
  width: 18px;
  height: 18px;

 @media (max-width: 3840px) {
width: 28px;
  height: 31px;


}
@media (max-width: 2560px) {
width: 22px;
  height: 22px;


}

@media (max-width: 1920px) {
  width: 20px;
  height: 20px;

  
  
  }
@media (max-width: 1600px) {
width: 18px;
  height: 18px;

}
`;
const ResponsiveIngredientIcon = styled(IngredientIcon)`
  width: 18px;
  height: 18px;

 @media (max-width: 3840px) {
width: 28px;
  height: 31px;


}
@media (max-width: 2560px) {
width: 22px;
  height: 22px;


}

@media (max-width: 1920px) {
  width: 20px;
  height: 20px;

  
  
  }
@media (max-width: 1600px) {
width: 18px;
  height: 18px;

}
`;
const ResponsiveBrandIcon = styled(BrandIcon)`
  width: 18px;
  height: 18px;

 @media (max-width: 3840px) {
width: 28px;
  height: 31px;


}
@media (max-width: 2560px) {
width: 22px;
  height: 22px;


}

@media (max-width: 1920px) {
  width: 20px;
  height: 20px;

  
  
  }
@media (max-width: 1600px) {
width: 18px;
  height: 18px;

}
`;

const ResponsiveNextArrow = styled(NextArrow)`
  width: 18px;
  height: 18px;

 @media (max-width: 3840px) {
width: 28px;
  height: 31px;


}
@media (max-width: 2560px) {
width: 22px;
  height: 22px;


}

@media (max-width: 1920px) {
  width: 20px;
  height: 20px;

  
  
  }
@media (max-width: 1600px) {
width: 18px;
  height: 18px;

}
`;